import { useEffect, useState } from "react";
import { Sun, Moon, MonitorSmartphone } from "lucide-react";
import { applyTheme, getPortalThemePref, setPortalThemePref } from "@/lib/theme";

const OPTIONS = [["light", "Claro", Sun], ["dark", "Escuro", Moon], ["auto", "Automático", MonitorSmartphone]];

// Seletor de tema do Portal do Paciente: guardado só neste dispositivo, independente do tema do profissional.
export default function PortalThemeToggle({ className = "" }) {
  const [pref, setPref] = useState(getPortalThemePref);
  useEffect(() => { applyTheme(); }, []);
  const choose = (v) => { setPref(v); setPortalThemePref(v); };
  return (
    <div role="radiogroup" aria-label="Tema" className={`inline-flex shrink-0 rounded-full border border-slate-700 bg-slate-900/70 p-0.5 ${className}`} data-testid="portal-theme-toggle">
      {OPTIONS.map(([v, label, Icon]) => (
        <button key={v} type="button" role="radio" aria-checked={pref === v} aria-label={label} title={label} onClick={() => choose(v)}
          data-testid={`portal-theme-${v}`}
          className={`inline-flex h-10 w-10 items-center justify-center rounded-full transition-colors ${pref === v ? "bg-sky-400/15 text-sky-300" : "text-slate-400 hover:text-slate-200"}`}>
          <Icon className="h-4 w-4" strokeWidth={1.6} />
        </button>
      ))}
    </div>
  );
}
